/**
 * Read/create the per-tab session ID (X-Session-ID, analytics correlation).
 * Kept separate from `sessionClear.ts` so production bundles never merge
 * `clearSessionId` with unrelated lazy-loading code (Rollup TDZ / duplicate `j`).
 */
const SESSION_ID_KEY = "app_session_id";

function generateSessionId(): string {
  return (
    crypto.randomUUID?.() ??
    `s${Date.now()}-${Math.random().toString(36).slice(2, 11)}`
  );
}

/**
 * Get the current session ID. Creates and stores one if missing.
 * Safe for SSR (returns a fallback string when sessionStorage is unavailable).
 */
export function getSessionId(): string {
  try {
    if (typeof window === "undefined" || !window.sessionStorage) {
      return "ssr";
    }
    let id = window.sessionStorage.getItem(SESSION_ID_KEY);
    if (!id) {
      id = generateSessionId();
      window.sessionStorage.setItem(SESSION_ID_KEY, id);
    }
    return id;
  } catch {
    return "ssr";
  }
}
